import { styled } from '@mui/material/styles'
import { NavLink, type NavLinkProps } from 'react-router-dom'

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  width: '100%',
  textDecoration: 'none',
  '&.sub-menu-item': {
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '14px',
      height: '100%',
      width: '1px',
      background: theme.palette.divider
    },
    '&.active, &:hover': {
      '&:before': {
        background: theme.palette.tertiary.main
      }
    }
  },
  '.MuiListItemText-root': {
    color: theme.palette.text.primary
  }
}))

function DrawerMenuItemLink({
  children,
  hasSubMenu,
  ...props
}: NavLinkProps & {
  children: React.ReactNode
  hasSubMenu?: boolean
}) {
  return hasSubMenu ? <span>{children}</span> : <StyledNavLink {...props}>{children}</StyledNavLink>
}

export default DrawerMenuItemLink
